import { getData } from '../modules/fetch';

const getWhatsappQR = async (storeId?: string): Promise<string> => {
  let url: string = '/platform/whatsapp-qr/init';
  if (storeId) {
    url = `${url}/${storeId}`;
  }
  const res = await getData(url);
  return res?.data?.qr ?? '';
};

export default getWhatsappQR;
